import cookieconsent from 'cookieconsent';



let rtn = {};




rtn.init = () => {

        window.cookieconsent.initialise({
            "cookie": {
                "name" : "consent"
            },
            "palette": {
                "popup": {
                    "background": "#fff",
                    "color": "#000"
                },
                "button": {
                    "background": "#000",
                    "color": "#fff"
                }
            },
            "theme": "edgeless",
            "position": "bottom-left",
            "content": {
                "message": "We use cookies, only to track visits to this website, we do not store personal details.",
                "dismiss": "CLOSE",
                "href": "http://www.htalentmanagement.com/privacy-cookie-policy"
            }
        })
   

}


module.exports = rtn;


// WEBPACK FOOTER //
// ./js/service/cookie-notice.js